/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import stringIdxImg from 'assets/images/stringIdx.png'

export const _9 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Введение</h2>
    <p className={styles.description}>
      <b>Строка</b> — это индексированный набор из нуля или более символов, заключенных в одинарные либо двойные
      кавычки.
    </p>
    <CopyBlock text={`const name = 'Mango';`} language="js" showLineNumbers={false} theme={ocean} />
    <p className={styles.description}>
      Важно помнить, что индексация элементов строки начинается с нуля. К примеру в строке{' '}
      <code className={styles.code}>'JavaScript'</code> буква <code className={styles.code}>'J'</code> стоит на позиции
      с индексом <code className={styles.code}>0</code>, а <code className={styles.code}>'t'</code> идет под индексом{' '}
      <code className={styles.code}>9</code>.
    </p>
    <img className={styles.img_without_shadow} src={stringIdxImg} alt="stringIdxImg" />
    <p className={styles.description}>
      Содержимое строки нельзя изменить. Нельзя взять символ посередине и заменить его. Как только строка создана — она
      такая навсегда. Можно лишь создать целиком новую строку и присвоить в переменную вместо старой.
    </p>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>2 - Конкатенация строк</h2>
      <p className={styles.description}>
        Если применить оператор <code className={styles.code}>+</code> к строке и любому другому типу данных,
        результатом операции «сложения» будет строка. Эта операция называется конкатенация, или сложение строк.
      </p>
      <p className={styles.description}>
        Во время конкатенации, любой тип данных приводится к строке и сшивается со строкой, но есть особенность —
        последовательность записи операндов.
      </p>
      <p className={styles.description}>
        Последовательность операций имеет значение, преобразование типов происходит только в момент операции сложения со
        строкой, до этого момента действуют привычные правила математики.
      </p>
      <CopyBlock
        text={`const message = 'Mango ' + 'is' + ' happy';
console.log(message); // Mango is happy

// Теперь посмотрим на порядок операндов
let result;

result = 5 + '5';
console.log(result); // '55'
console.log(typeof result); // string

result = 5 + '5' + 5;
console.log(result); // '555'
console.log(typeof result); // string

/*
 * Обратите внимание, произошла математическая операция
 * сложения для первых двух пятерок, после чего 10 было
 * преобразовано в строку '10' и сшито с '5'
 */
result = 5 + 5 + '5';
console.log(result); // '105'
console.log(typeof result); // string
`}
        language="js"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>3 - Свойства и методы строк</h2>
      <p className={styles.description}>
        У каждой строки есть встроенные свойства и методы, рассмотрим некоторые из них.
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>length</code> - свойство, хранит длину строки
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>toLowerCase()</code> и <code className={styles.code}>toUpperCase()</code> -
          вернут новую строку в соответствующем регистре, не изменяют оригинальную строку
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>indexOf()</code> - вернет позицию (индекс) на которой находится первое
          совпадение подстроки или <code className={styles.code}>-1</code>, если ничего не найдено
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>includes()</code> - один из наиболее часто используемых методов, в большинстве
          случаев заменяет <code className={styles.code}>indexOf</code>, проверяет входит ли подстрока в строку,
          возвращает
          <code className={styles.code}>true</code> или <code className={styles.code}>false</code>
        </li>
      </ul>
      <CopyBlock
        text={`const message = 'Welcome to Bahamas!';

console.log(message.length); // 19
console.log('There is nothing impossible to him who will try'.length); // 47

console.log(message.toLowerCase()); // welcome to bahamas!
console.log(message.toUpperCase()); // WELCOME TO BAHAMAS!

// При этом исходная строка не изменяется
console.log(message); // Welcome to Bahamas!

console.log(message.indexOf('to')); // 8
console.log(message.indexOf('hello')); // -1

// Все методы строк чувствительны к регистру
console.log(message.includes('welcome')); // false
console.log(message.includes('Welcome')); // true
`}
        language="js"
        showLineNumbers={false}
        theme={ocean}
      />
      <a
        className={styles.link}
        rel="noopener noreferrer"
        href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#Methods_2"
        target="_blank"
      >
        Полный список методов на MDN
      </a>
    </section>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>4 - Шаблонные строки и интерполяция</h2>
      <p className={styles.description}>
        Шаблонные строки - это альтернатива конкатенации с более удобным синтаксисом. Они заключены в обратные кавычки
        вместо двойных или одинарных и могут содержать местозаполнители, которые обозначаются знаком доллара и фигурными
        скобками.
      </p>
    </section>
  </section>
))
